import * as React from 'react';
import styled from 'styled-components';
import { NavLink, Link } from 'react-router-dom';
import { CommonTs, langAll, langWord } from '../../locales';

interface IProps {
  messages: CommonTs;
  lang: string;
}

const HeaderStyle = ({ messages, lang }: IProps) => {

  let langUrl = `/${lang}`;

  const { pathname } = window.location;

  if (window.location && pathname.indexOf(lang) < 0) {
    langUrl = '';
  }

  return (
    <Header>
      <Logo><Link to='/home'>{messages.logo}</Link></Logo>
      <Nav>
        <ul>
          {
            messages.nav.map((item, i) =>
              <li key={i}>
                <NavLink to={`${langUrl}${item.href}`} className={item.sub && 'sub'} target={item.target && `${item.target}`}>{item.cur}</NavLink>
                {
                  item.sub &&
                  <SubNav>
                    <ul>
                      {
                        item.sub.map((list, j) =>
                          <li key={j}><Link to={`${langUrl}${list.href}`} target={list.target && `${list.target}`}>{list.cur}</Link></li>
                        )
                      }
                    </ul>
                  </SubNav>
                }
              </li>
            )
          }
        </ul>
      </Nav>
      <User>
        {
          messages.signup.map((item, i) =>
            <Link to={`${langUrl}${item.href}`} target={item.target && `${item.target}`} key={i}>{item.cur}</Link>
          )
        }
        <LangSel>
          <button type="button">{langWord[lang]}</button>
          <SubNav>
            <ul>
              {
                langAll.map((item, i) =>
                  <li key={i}><a href={`${pathname.indexOf(lang) > 0 ? pathname.replace(lang, item) : `/${item}${pathname}`}`}>{langWord[item]}</a></li>
                )
              }
            </ul>
          </SubNav>
        </LangSel>
      </User>
    </Header>
  )
}

export default HeaderStyle;


const Header = styled.header`
  position: relative;
  margin: 0 auto;
  padding: 0 0 0 265px;
  width: 1240px; height: 80px;
`;

const Logo = styled.h1`
  position: absolute;
  top: 0; left: 0;
  height: 100%;

  & > a {
    display: block;
    padding: 20px;
    width: 225px; height: 100%;
    font-size: 0;
    line-height: 0;
    background: url(${require('../../assets/common/logo@2x.png')}) 20px 20px no-repeat;
    background-size: 185px auto;
  }
`

const Nav = styled.div`
  width: 100;

  font-size: 0;

  & a {
    display: block;
    padding: 0 20px;
    color: #202020;

    &:hover,
    &:active,
    &:focus {
      color: #9b8a70;
    }
  }

  & > ul > li {
    display: inline-block;
    position: relative;
  }

  & > ul > li > a {
    position: relative;
    line-height: 80px;
    font-size: 16px;
    font-weight: bold;

    &.active,
    &.on {
      color: #9b8a70;
    }

    &:hover:before,
    &.active:before {
      content:"";
      display: block;
      position: absolute;
      top: 60px; left: 20px;
      width: calc(100% - 40px); height: 2px;
      background: #b6aa92;
    }

    &:hover + div {
      display: block;
    }

    &.sub {
      padding: 0 35px 0 20px;
    }

    &.sub:after {
      content: "";
      position: absolute;
      top: 50%; right: 20px;
      margin-top: -2.5px;
      width: 8px; height: 5px;
      background: url(${require('../../assets/common/triangle@2x.png')}) 0 0 no-repeat;
      background-size: 8px auto;
    }

    &.sub:hover:after,
    &.sub.active:after {
      background-image: url(${require('../../assets/common/triangle-on@2x.png')});
    }
  }

`;

const SubNav = styled.div`
  display: none;
  position: absolute;
  top: 60px; left: 0;
  background: #fff;
  z-index: 1;

  & a {
    display: block;
    padding: 0 20px !important;
    color: #202020;

    &:hover,
    &:active,
    &:focus {
      color: #9b8a70;
    }
  }

  &:hover {
    display: block;
  }

  & ul {
    padding: 20px 0;
    border-top: 2px solid #b6aa92;
    border-radius: 0 0 5px 5px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  }

  & ul > li > a {
    line-height: 28px;
    font-size: 14px;
    white-space: nowrap;
  }
`

const User = styled.div`
  position: absolute;
  top: 26px; right: 0;
  line-height: 26px;
  font-size: 0;
  & a {
    display: inline-block;
    position: relative;
    padding: 0 10px;
    color: #898989;
    font-size: 14px;

    &:before {
      content: "";
      position: absolute;
      top: 50%; left: 0;
      margin-top: -5px;
      width: 1px; height: 12px;
      background-color: #dcd9d4;
    }
    &:first-child:before {
      display: none;
    }
  }
`;

const LangSel = styled.div`
  display: inline-block;
  position: relative;
  margin-left: 10px;
  vertical-align: top;

  & button {
    padding: 0 22px 0 36px;
    height: 26px;
    font-size: 13px;
    border: 1px solid #dcd9d4;
    background-color: #f9f9f9;

    &:after {
      content: "";
      position: absolute;
      top: 50%; right: 5px;
      margin-top: -2.5px;
      width: 8px; height: 5px;
      background: url(${require('../../assets/common/triangle-on@2x.png')}) 0 0 no-repeat;
      background-size: 8px auto;
    }

    &:hover + div {
      display: block;
    } 
  }

  &> div {
    top: 26px; left: auto; right: 1px;
    padding-top: 7px;
  }
`;




// WEBPACK FOOTER //
// ./src/styles/layout/header.tsx